import { Injectable } from '@angular/core';
import type { Observable } from 'rxjs';
import { BaseApiService } from '../../../core/api/base-api.service';
import type { IntegrationsListTemplatesDataResponse } from '../../../core/api/generated/models/IntegrationsListTemplatesDataResponse';
import type { SyncTemplatesRequest } from '../../../core/api/generated/models/SyncTemplatesRequest';

export interface SyncChannelTemplatesRequest {
  readonly externalAccountId?: string | null;
}

@Injectable({ providedIn: 'root' })
export class IntegrationTemplatesApiService extends BaseApiService {
  protected override readonly resourcePath = '/v1/integrations';

  listForIntegration(
    integrationId: string,
  ): Observable<IntegrationsListTemplatesDataResponse> {
    return this.get<IntegrationsListTemplatesDataResponse>([integrationId, 'templates']);
  }

  listForChannel(
    integrationId: string,
    channelAccountId: string,
    options: { eligibleForSend?: boolean } = {},
  ): Observable<IntegrationsListTemplatesDataResponse> {
    const params: Record<string, string> = {};
    if (options.eligibleForSend) params['eligibleForSend'] = 'true';
    return this.get<IntegrationsListTemplatesDataResponse>(
      [integrationId, 'channels', channelAccountId, 'templates'],
      Object.keys(params).length > 0 ? { params } : undefined,
    );
  }

  sync(integrationId: string, payload: Partial<SyncTemplatesRequest>): Observable<unknown> {
    return this.post([integrationId, 'templates', 'sync'], payload);
  }

  syncChannel(
    integrationId: string,
    channelAccountId: string,
    payload: SyncChannelTemplatesRequest = {},
    options: { ifStale?: boolean } = {},
  ): Observable<unknown> {
    const path: (string | number)[] = [integrationId, 'channels', channelAccountId, 'templates', 'sync'];
    const httpOptions = options.ifStale
      ? { params: { ifStale: 'true' } }
      : undefined;
    return this.post(path, payload, httpOptions);
  }
}
